import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faTasks,
  faEdit,
  faHistory,
  faExclamationCircle,
  faCoins,
  faComments,
  } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import { POSICION_DEUDOR_WRITE } from 'helpers/profilePermission';
import isUserHasProfile from 'helpers/profileValidator';
import useTableFilters from 'helpers/useTableFilters';
import { FRONT_DF_1, BASE_URL, API, FILTROS_TEXTO, ESTADO_LINEA, ESTADOS_MOVIMIENTOS } from 'CONST';
import FilterSelect from 'components/shared/FilterSelect';
import { get } from '../../../helpers/requests';
import ComentariosModal from './comentariosModal';
import PosicionDeudorModal from './posicionDeudorModal';
import PosicionDeudorHistoryModal from './posicionDeudorHistoryModal';
import PosicionDeudorLegendModal from './posicionDeudorLegendModal';
import PosicionDeudorReporteConsolidadoModal from './posicionDeudorReporteConsolidadoModal';
import Icon from '../../UI/Icon';
import { getIconInfo } from "../../../helpers/helpersMotor";
import WarningModal from '../../UI/WarningModal';
import {
  headerOperation,
  headerDoubleRowOperation,
  cellOperation,
  cellNumOperation,
  cellFloatOperation,
  headerDoubleRowOperationCenter
} from '../../../helpers/tables';
import BaseTable from '../../shared/BaseTable';
import DownloadBtn from '../../shared/DownloadBtn';
import { fdate } from '../../../helpers/helpers';
import BalanceCreditoContext from './balanceCreditoContext';

const PosicionDeudorTable = ({ id, edit, datosDeudor, isForeign, datosScoreByMov, monedaAsegurada }) => {
  const { setBalanceCreditoData } = useContext(BalanceCreditoContext);
  const DEFAULT_VALUE = -1;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalComments, setModalComments] = useState(false);
  const [modalHistoryOpen, setModalHistoryOpen] = useState(false);
  const [modalLegendOpen, setModalLegendOpen] = useState(false);
  const [movimiento, setMovimiento] = useState();
  const [linea, setLinea] = useState();
  const [botones, setBotones] = useState({
    'Todas las líneas': true,
    'Pendientes': false,
    'Estado Actual': false,
    [FILTROS_TEXTO.montos_vigentes]: false,
  });
  const [reporteConsolidadoModal, setReporteConsolidadoModal] = useState(false);
  const [reporteConsolidadoTimestamp, setReporteConsolidadoTimestamp] = useState('');
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [estadosLinea, setEstadosLinea] = useState([]);
  const [datosScore, setDatosScore] = useState({});
  const todas = {
    texto: FILTROS_TEXTO.todas,
    busqueda: FILTROS_TEXTO.historicas,
  }
  const vigentes = {
    texto: FILTROS_TEXTO.vigentes,
  };
  const montosVigentes = {
    texto: FILTROS_TEXTO.montos_vigentes,
  };
  const pendientes = {
    texto: FILTROS_TEXTO.pendientes,
    busqueda: `${ESTADO_LINEA.pendiente}`,
  };

  const [queryParams, setQueryParams] = useState(`linea_credito__deudor_id=${id}&historicas=true&ordering=-fecha_solicitud`);
  const [onFilteredChange, onFetchData, loading, data, getData] = useTableFilters(
    `${BASE_URL}${API.balanceCredito}`,
    false,
    queryParams,
    [],
    0,
  );
  // const [isListaNegra, setListaNegra] = useState(false);

  const tableRef = useRef(null);

  const toggleModal = (record) => {
    setModalOpen(!modalOpen);
    setMovimiento(record);
  };

  const toggleHistoryModal = (record) => {
    setModalHistoryOpen(!modalHistoryOpen);
    setLinea(record && record.linea_credito);
  };

  const toggleLegendModal = () => {
    setModalLegendOpen(false);
  };

  useEffect(() => {
    if (data) {
      setBalanceCreditoData(data);
    }
  }, [data, setBalanceCreditoData]);

  useEffect(() => {  
    getData(queryParams);
  
    get(`${BASE_URL}${API.estadosLinea}`).then((response) => {
      setEstadosLinea(
        response.results.map((elem) =>
          elem.nombre === "Limitada"
            ? { ...elem, nombre: "Aprobado Parcial" }
            : elem
        )
      );
    });
  
    // get(`${BASE_URL}${API.deudor}/${id}`).then((response) => {
    //  setListaNegra(response.estado === "bloqueado");
    // });
  }, [edit]);

  const onAcceptModal = () => {
    setModalOpen(!modalOpen);
    tableRef.current.state.page = 0;
    onFetchData(tableRef.current.state);
  };

  const changeButtons = (text) => {
    setBotones({
      'Todas las líneas': text === FILTROS_TEXTO.todas,
      'Pendientes': text === FILTROS_TEXTO.pendientes,
      'Estado Actual': text === FILTROS_TEXTO.vigentes,
      [FILTROS_TEXTO.montos_vigentes]: text === FILTROS_TEXTO.montos_vigentes,
    });
  };

  const toggleReporteConsolidadoModal = () => {
    setReporteConsolidadoModal(false);
  };

  const toggleWarningModal = () => {
    setOpenWarningModal(false);
  };

  const handleReporteConsolidadoModal = (item) => {
    setDatosScore(
      item.id in datosScoreByMov
        ? datosScoreByMov[item.id].data
        : {},
    );

    setReporteConsolidadoTimestamp(item.creacion_ts)
    setReporteConsolidadoModal(true);
  };

  const columns = [
    {
      Header: headerOperation('ID'),
      id: 'linea_credito__id',
      accessor: 'linea_credito.id',
      Cell: (row) => cellOperation(row.value, 'right'),
      minWidth: 100,
      sortable: false,
    },
    {
      Header: headerOperation('Asegurado'),
      id: 'linea_credito__cliente',
      accessor: 'asegurado_nombre',
      Cell: (row) => cellOperation(row.value, 'left'),
      minWidth: 240,
      sortable: false,
    },
    {
      Header: headerOperation('Póliza'),
      id: 'poliza',
      accessor: 'poliza',
      Cell: (row) => cellOperation(row.value),
      minWidth: 140,
      sortable: false,
    },
    {
      Header: headerOperation('Moneda'),
      id: 'moneda_asegurada',
      accesor: 'moneda_asegurada',
      Cell: (row) => cellOperation(row.original.moneda_asegurada, 'right'),
      minWidth: 75,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Monto', 'solicitado'),
      id: 'monto_solicitado',
      accessor: 'linea_solicitada',
      Cell: (row) => {
        // Comprobar si existe el estado de la línea y si es "bloqueado"
        if (row.original.estado_linea && row.original.estado_linea.nemotecnico === "bloqueado") {
          return cellNumOperation(null, 'right');
        }
    
        // Retornar el valor normal si la condición no se cumple
        return cellNumOperation(row.value || 0);
      },
      minWidth: 130,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Monto', 'aprobado'),
      id: 'monto_otorgado',
      accessor: 'monto_otorgado',
      Cell: (row) => cellNumOperation(row.value || 0),
      minWidth: 130,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Monto', 'vigente'),
      id: 'monto_vigente',
      accessor: 'monto_vigente',
      Cell: (row) => cellNumOperation(row.value || 0),
      minWidth: 130,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Tipo', 'Deudor'),
      id: 'tipo_deudor_name',
      accessor: 'tipo_deudor_name',
      Cell: (row) => cellOperation(row.value, 'left'),
      minWidth: 130,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Estado'),
      id: 'balance_display',
      accessor: 'balance_display',
      Cell: ({ value }) => cellOperation(value, 'center'),
      Filter: (obj) => (
        <FilterSelect
          filter={obj.filter}
          onFilterChange={(value) => {
            if (value === DEFAULT_VALUE || value === -1) {
              obj.onChange(undefined);
            } else {
              obj.onChange(value);
            }
          }}
          options={[
            { label: 'Actual', value: 'Actual' },
            { label: 'Histórico', value: 'Histórico' },
            { label: '-', value: '-' },
          ]}
          defaultOption={{ label: 'Todos', value: DEFAULT_VALUE }}
        />
      ),
      minWidth: 130,
      filterable: true,
      sortable: false,
      filterMethod: (filter, row) => {
        if (filter.value === DEFAULT_VALUE || filter.value === undefined) {
          return true;
        }
        const balanceDisplay = row[filter.id];
        return balanceDisplay === filter.value;
      },
    },
    {
      Header: headerOperation('Estado línea'),
      id: 'estado_linea__id',
      accessor: (row) => {
        const estadoNombre = row.estado_linea?.nombre;
        if (estadoNombre === "Limitada") return "Aprobado Parcial";
        if (estadoNombre === "Bloqueado") return "Bloqueada";
        return estadoNombre;
      },
      Cell: (row) => cellOperation(row.value, 'center'),
      Filter: (obj) => (
        <FilterSelect
          filter={obj.filter}
          onFilterChange={obj.onChange}
          options={estadosLinea.map((elem) => {
            let label = elem.nombre;
            if (elem.nombre === "Limitada") label = "Aprobado Parcial";
            if (elem.nombre === "Bloqueado") label = "Bloqueada";
            return { label, value: elem.id };
          })}
          defaultOption={{ label: 'Todos', value: DEFAULT_VALUE }}
        />
      ),
      minWidth: 160,
      sortable: false,
    },
    ...(!datosDeudor.isForeign ? [{
      Header: headerDoubleRowOperationCenter('Decisión Motor', 'Exclusión'),
      id: 'estado__descripcion',
      accessor: row => row.estado_descripcion === 'Pendiente' 
        ? row.decision_bypass_monto 
        : row.estado_descripcion,
      Cell: (row) =>
        getIconInfo(row),
      minWidth: 100,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Score'),
      id: 'score',
      accessor: 'score',
      Cell: (row) => cellFloatOperation(row.value, 1),
      minWidth: 60,
      sortable: false,
      filterable: false,
    }] : []),
    {
      Header: headerDoubleRowOperation('Fecha', 'solicitud'),
      id: 'fecha_solicitud',
      accessor: 'fecha_solicitud',
      Cell: (row) => cellOperation(fdate(row.value, FRONT_DF_1)),
      minWidth: 125,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Fecha', 'resolución'),
      id: 'fecha_respuesta',
      accessor: 'fecha_respuesta',
      Cell: (row) => {
        if (row.original.linea_credito?.estado?.nemotecnico === ESTADOS_MOVIMIENTOS.pendiente &&
          row.original.balance_display === '-'
        ) {
          return cellOperation('-');
        }
        return cellOperation(fdate(row.value, FRONT_DF_1))
      },
      minWidth: 125,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Fecha inicio', 'cobertura'),
      id: 'fecha_vigencia',
      accessor: 'fecha_vigencia',
      Cell: (row) => {
        if (row.original.estado_linea && row.original.estado_linea.nemotecnico === "rechazada") {
          return cellOperation('-');
        }
        return cellOperation(fdate(row.value, FRONT_DF_1));
      },
      minWidth: 125,
      filterable: false,
    },
    {
      Header: headerDoubleRowOperation('Fin de', 'cobertura'),
      id: 'fecha_fin_cobertura',
      accessor: 'fecha_fin_vigencia',
      Cell: (row) => {
        if (row.original.estado_linea && row.original.estado_linea.nemotecnico === "rechazada") {
          return cellOperation('-');
        }
        return cellOperation(fdate(row.value, FRONT_DF_1));
      },
      minWidth: 125,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Analista ', 'asignado'),
      id: 'analista_asignado',
      accessor: 'analista',
      Cell: (row) =>
        cellOperation(
          row.value && row.value.user
            ? `${row.value.user.first_name} ${row.value.user.last_name}`
            : '-',
          'right',
        ),
      minWidth: 150,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerDoubleRowOperation('Comentarios', 'y Motivos'),
      id: 'comentarios',
      accessor: 'motivo',
      Cell: (row) =>
        cellOperation(
          <div>
            <Icon
              id={`comentario-analista-icon-${row.original.id}`}
              tooltipText="Comentarios"
              handleOnClick={() => {
                setModalComments(true);
                setMovimiento(row.original);
              }}
            >
              <FontAwesomeIcon icon={faComments} />
            </Icon>
          </div>,
        ),
      minWidth: 140,
      filterable: false,
      sortable: false,
    },
    {
      Header: headerOperation('Acciones'),
      id: 'acciones',
      fixed: 'right',
      Cell: ({ original }) =>
        cellOperation(
          <div
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridGap: '5px' }}
            className="table-cell"
          >
            {!isForeign && (
              <div style={{ textAlign: 'center' }} title="Reporte Consolidado">
                {!(
                  (original.tipo_solicitud === null && original.estado_linea.nombre === 'Bloqueado') ||
                  (original.tipo_solicitud === null && original.estado_linea.nombre === 'Reducido') ||
                  (original.tipo_solicitud === null && original.estado_linea.nombre === 'Deshabilitada')
                ) && (
                  <Button
                    className="table-link"
                    id="reporteConsolidado"
                    onClick={() => handleReporteConsolidadoModal(original)}
                  >
                    <FontAwesomeIcon icon={faCoins} />
                  </Button>
                )}
              </div>
            )}
            <div style={{ textAlign: 'center' }} title="Histórico">
              <Button
                className="table-link"
                id="iconAcciones"
                onClick={() => toggleHistoryModal(original)}
              >
                <FontAwesomeIcon icon={faHistory} />
              </Button>
            </div>
            {isUserHasProfile(POSICION_DEUDOR_WRITE) &&
              !botones['Históricas'] &&
              (original.is_balance || original.balanceDisplay === 'Actual') &&
              (original.linea_credito.estado &&
                original.linea_credito.estado.nombre !== ESTADO_LINEA.pendiente ? (
                  <div style={{ textAlign: 'center' }} title="Acciones Línea">
                    <Button
                      className="table-link"
                      id="iconAcciones"
                      onClick={() => toggleModal(original)}
                    >
                      <FontAwesomeIcon icon={faTasks} />
                    </Button>
                  </div>
              ) : (
                <div style={{ textAlign: 'center' }} title="Resolver Solicitud">
                  <Link to={`/inbox-riesgos/${original.id}`} className="table-link">
                    <FontAwesomeIcon icon={faEdit} />
                  </Link>
                </div>
              ))}
          </div>,
        ),
      minWidth: 160,
      filterable: false,
      sortable: false,
    },
  ];

  const handleFilterButton = (params, texto) => {
    setQueryParams(params);

    const tableInstance = tableRef.current?.props?.innerRef?.current;

    if (tableInstance?.state) {
      tableInstance.state.newParams = params;
      tableInstance.state.page = 0;
      onFetchData(tableInstance.state);
    } else {
      const basicState = {
        newParams: params,
        page: 0,
        pageSize: 20,
        sorted: [],
        filtered: []
      };
      onFetchData(basicState);
    }
    changeButtons(texto);
  };

  const FilterButton = (object) => {
    const { texto } = object.estado;
    let params = ``;
    if (object.estado && object.estado.texto === FILTROS_TEXTO.todas) {
      params = `linea_credito__deudor_id=${id}&historicas=true`;
    } else if (object.estado?.texto === FILTROS_TEXTO.vigentes) {
      params = `linea_credito__deudor_id=${id}`;
    } else if (object.estado?.texto === FILTROS_TEXTO.montos_vigentes) {
      params = `linea_credito__deudor_id=${id}&historicas=true&filterVigentes`;
    } else {
      params = object.estado
        ? `linea_credito__deudor_id=${id}&linea_credito__estado__nombre__in=${object.estado.busqueda}`
        : `linea_credito__deudor_id=${id}`;
    }

    return (
      <Button
        className={object.botones[texto] ? 'btn-orsan-outline' : 'btn-orsan'}
        style={{
          marginLeft: '0.5rem',
          width: '10rem',
          height: '26px',
          padding: '0',
        }}
        onClick={() => handleFilterButton(params, texto)}
      >
        {texto}
      </Button>
    );
  };

  return (
    <div style={{ margin: '25px 0 40px 0', width: '100%' }}>
      <div style={{ marginBottom: '1rem' }}>
        Mostrar:
        <FilterButton estado={todas} botones={botones} />
        <FilterButton estado={pendientes} botones={botones} />
        <FilterButton estado={vigentes} botones={botones} />
        <FilterButton estado={montosVigentes} botones={botones} />
        <div style={{ display: 'inline-block', float: 'right' }}>
          <DownloadBtn
            width="auto"
            id="xlsx-download"
            text={`Descarga ${Object.keys(botones).filter((key) => botones[key])}`}
            tipText={`Descarga ${Object.keys(botones).filter((key) => botones[key])}`}
            url={`${BASE_URL}${API.movimientoLineaCredito
              }historial-movimientos-deudor/?deudor=${id}&tipo_descarga=${Object.keys(botones).filter(
                (key) => botones[key],
              )}`}
          />
        </div>
      </div>
      <BaseTable
        tableRef={tableRef}
        columns={columns}
        data={data.data}
        loading={loading}
        onFetchData={onFetchData}
        onFilteredChange={onFilteredChange}
        pages={data.pages}
        resultCount={data.count}
        resizable={false}
        filterable
        showPagination
        noBorders
        hasFixedColumns
      />
      <ComentariosModal movimiento={movimiento} openModal={modalComments} toggleModal={() => setModalComments(false)} />
      <PosicionDeudorModal
        openModal={modalOpen}
        toggleModal={toggleModal}
        movimiento={movimiento}
        onAcceptModal={onAcceptModal}
      />
      <PosicionDeudorHistoryModal
        openModal={modalHistoryOpen}
        toggleModal={toggleHistoryModal}
        linea={linea}
        monedaAsegurada={monedaAsegurada}
      />
      <PosicionDeudorLegendModal openModal={modalLegendOpen} toggleModal={toggleLegendModal} />
      <PosicionDeudorReporteConsolidadoModal
        isOpen={reporteConsolidadoModal && !!reporteConsolidadoTimestamp}
        toggle={toggleReporteConsolidadoModal}
        datosDeudor={datosDeudor}
        datosScore={datosScore}
        selectedTimestamp={reporteConsolidadoTimestamp}
      />
      <WarningModal
        isOpen={openWarningModal}
        toggle={toggleWarningModal}
        handleOk={() => setOpenWarningModal(false)}
        loading={false}
        confirmMsg="Reporte Consolidado inexistente"
        cancelBtnText="OK"
        onlyCancelButton
      />
    </div>
  );
};

PosicionDeudorTable.propTypes = {
  id: PropTypes.string.isRequired,
  edit: PropTypes.bool.isRequired,
  isForeign: PropTypes.bool,
  datosDeudor: PropTypes.shape({
    rut: PropTypes.string,
    name: PropTypes.string,
    estado: PropTypes.string,
    inicio_actividad: PropTypes.string,
    actividad: PropTypes.arrayOf(PropTypes.object),
    rubro_id: PropTypes.number,
    tamano: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    contacto: PropTypes.string,
    score: PropTypes.number,
    isForeign: PropTypes.bool,
  }).isRequired,
  datosScoreByMov: PropTypes.object.isRequired,
  monedaAsegurada: PropTypes.string.isRequired,
};
 
PosicionDeudorTable.defaultProps = {
  isForeign: false,
};
 

export default PosicionDeudorTable;
